import React, { useState, useRef, useCallback } from "react";
import Style from "./Settings.module.css";
import Cloud from "../../assets/svg/cloud.svg";
import Delete from "../../assets/svg/delete.svg";
import logo from "../../assets/hanshi/full-lg.svg";
import Modal from "../../components/controls/modal/Modal";

const UploadLogo = (props) => {
  const { handleCancel, uploadImage, showLoading, displayImage } = props;
  const [isRemove, setIsRemove] = useState(false);
  const [uploadedFile, setUploadedFile] = useState(displayImage);
  const [toUploadfile, setToUploadfile] = useState(displayImage);


  const handleSave = (event) => {
    event.preventDefault();

    const formData = new FormData();
    formData.append("file", toUploadfile);
    formData.append("isdelete", false);
    uploadImage(formData);
  };

  const handlePreview = (e) => {
    const file = e.target.files[0];
    if(file){
      setToUploadfile(file);
      const reader = new FileReader();
      reader.onload = () => {
        setUploadedFile(reader.result);
      };
      reader.readAsDataURL(file);
    }

  };

  const handleRemove = (event) => {
    event.preventDefault();
    const formData = new FormData();
    formData.append("isdelete", true);
    uploadImage(formData);
  };
  const removeImageModalBody = () => {
    return (
      <div>
        <div>
          <div className={Style.imgPreview}>
            <img src={uploadedFile || logo} alt="" />
          </div>
          <div>
            <p className={Style.changeOrRemove}>
              Are you sure you want to remove the picture?
            </p>
          </div>
        </div>
      </div>
    );
  };

  const changeImageModalBody = () => {
    return (
      <div className={`font-family-imp`}>
        <div>
          <div className={Style.imgPreview}>
            <img src={uploadedFile || logo} alt="" />
          </div>
          <div className="d-flex gap-4">
            <div className={Style.changePictureWrapper}>
              <img src={Cloud} alt="" />
              <label htmlFor="file-upload" className={Style.changePictureTitle}>
                Change picture
              </label>
              <input
                type="file"
                id="file-upload"
                className={Style.customFileInput}
                onChange={handlePreview}
              />
            </div>
            <div className={Style.changePictureWrapper}>
              <img src={Delete} alt="" />
              <p
                className={Style.removeTitle}
                onClick={() => setIsRemove(true)}
              >
                Remove
              </p>
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <>
      <Modal
        title={isRemove ? "Remove picture" : "Change picture"}
        body={isRemove ? removeImageModalBody() : changeImageModalBody()}
        handleCancel={() => (isRemove ? setIsRemove(false) : handleCancel())}
        handleSave={(e) => (isRemove ? handleRemove(e) : handleSave(e))}
        saveBtnLabel={isRemove ? "Yes" : "Save"}
        cancelBtnLabel={isRemove ? "No" : "Cancel"}
        isLoading={showLoading}
        size="small"
      />
    </>
  );
};

export default UploadLogo;
